import React from 'react'
import styled from 'styled-components'
import { colors } from '../../../../../../../assets/colors'
import { Button } from '../../../../../../../components/Button'
import Icon from '../../../../../../../components/Icon'

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
`

const ModalContainer = styled.div`
  background: ${colors.white};
  border-radius: 12px;
  padding: 30px;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`

const IconContainer = styled.div`
  background: ${colors.darkBlue};
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
`

const Title = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: ${colors.darkGrey};
  margin: 0 0 12px 0;
`

const Message = styled.p`
  font-size: 15px;
  color: ${colors.mediumGrey};
  line-height: 1.5;
  margin: 0 0 8px 0;
`

const SubMessage = styled.p`
  font-size: 13px;
  color: ${colors.mediumGrey};
  margin: 0 0 25px 0;
  font-style: italic;
`

const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`

interface DownloadConfirmationModalProps {
  show: boolean
  onClose: () => void
}

const DownloadConfirmationModal: React.FC<DownloadConfirmationModalProps> = ({ show, onClose }) => {
  if (!show) return null

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  return (
    <ModalOverlay onClick={handleOverlayClick}>
      <ModalContainer>
        <IconContainer>
          <Icon name="checkmark" fill={colors.white} width="24px" />
        </IconContainer>
        
        <Title>Download Queue Started!</Title>
        
        <Message>
          Your download request has been submitted successfully. We&apos;re now preparing your saved messages as ZIP files.
        </Message>
        
        <SubMessage>
          This process may take several minutes depending on the number of messages. You can check the status using the &quot;Check Download Status&quot; button.
        </SubMessage>
        
        <ButtonContainer>
          <Button
            type="button"
            onClick={onClose}
            style={{
              minWidth: '120px',
              background: colors.darkBlue,
              color: colors.white
            }}
          >
            Got it
          </Button>
        </ButtonContainer>
      </ModalContainer>
    </ModalOverlay>
  )
}

export default DownloadConfirmationModal 